<template lang="pug">
  #AdminSuperMemberMilestones
    BField(
      label="Challenge ID"
    )
      BInput(
        placeholder="Challenge ID"
        v-model="challengeId"
      )
    WtButton(@click.native="getMilestones" :loading="milestonesLoading") Get Milestones

    .box.bordered.mt-3(v-if="memberMilestones")
      ol
        li(v-for="milestone in memberMilestones") {{ milestone.title }}
</template>

<script>
import WtButton from "@@/WtButton/WtButton";

export default {
  name: "AdminSuperMemberMilestones",

  components: {
    WtButton
  },

  props: {
    memberId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      memberMilestones: null,
      challengeId: null,
      milestonesLoading: false
    };
  },

  computed: {},

  mounted() {},

  methods: {
    async getMilestones() {
      if (this.$auth.user().isWtAdmin) {
        try {
          this.milestonesLoading = true;
          let response = await this.axios.get(
            `members/${this.memberId}/milestones`,
            { params: { challengeId: this.challengeId } }
          );
          this.memberMilestones = response.data.data;
        } catch (error) {
          console.log("getMilestones -> error", error);
          this.memberMilestones = null;
        }
        this.milestonesLoading = false;
      }
    }
  }
};
</script>

<style lang="sass" scoped></style>
